// extracted by mini-css-extract-plugin
module.exports = {"cont":"ChatV1SearchBar_cont__3mLYB","contBtn":"ChatV1SearchBar_contBtn__1WHY3"};